<template>
  <ux-form ref="form" :data="formData" :rules="rules" label-width="auto" data-automation="userName">
    <ux-form-item :label="$t('HT.addUser.user')" required prop="username">
      <ux-input
        v-model.trim()="formData.username"
        class="username-input"
        size="small"
        :maxlength="30"
        :placeholder="$t('HT.addUser.user.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          username: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.changeUsername(this)
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.username-input {
  width: 300px;
}
</style>
